/**
 * Interface para las props de un contenedor de caja
 *
 * @typedef {Object} initialStateType
 * @property {Object} formRegister
 * @property {Object<boolean, React.ReactNode>} modalController
 * @property {Object} headerAdminItems
 * @property {Object} navAdminItems
 * @property {Object} loginUser
 * @property {Object} responseNotification
 * @property {boolean} showFilters
 * @property {boolean} initLoadError
 * @property {Array} provinces
 * @property {Array} entityTypes
 * @property {Array} tabs
 * @property {Array} roadTypes
 * @property {Array} administrationLevels
 * @property {Array} serviceStatus
 * @property {Array} serviceTypes
 * @property {Array} userTypes
 * @property {Array} denyReasons
 * @property {Array} periodictyAdvices
 * @property {Array} serviceCards
 * @property {Object} infoHome
 * @property {number} indicesPlusvaliasListadoTab
 * @property {Object} adminData
 * @property {number} escriturasListadotab
 * @property {Object} plusvaliasInfoHome
 * @property {Object} encontrarNotarioInfoHome
 * @property {Object} adminUserConfig
 * @property {Object} currentNotario
 * @property {Object} markersCoords
 * @property {Object} notariosData
 * @property {Object} userLocation
 * @property {Object} notariosLocations
 * @property {number} manageAdminTab
 * @property {number} activeTab
 */

/** @type initialStateType */
const initialState = {
	formRegister: {},
	modalController: {
		show: false,
		component: <></>,
	},
	headerAdminItems: {},
	navAdminItems: [],
	loginUser: {
		isLogin: false,
		userId: null,
		role: null,
		nif: null,
		nombre: '',
		apellido1: '',
		apellido2: '',
		avatar: '',
		email: '',
		telefono: '',
		nombreAdministracion: '',
		tipoUsuario: '',
		legalAgreed: false,
		servicesConfigured: false,
	},
	responseNotification: {
		notificationMessage: '',
		notificationStatus: 'error',
	},
	showFilters: false,
	initLoadError: false,
	provinces: [],
	entityTypes: [],
	roadTypes: [],
	administrationLevels: [],
	serviceStatus: [],
	serviceTypes: [],
	userTypes: [],
	denyReasons: [],
	periodictyAdvices: [],
	serviceCards: [],
	infoHome: {},
	indicesPlusvaliasListadoTab: 1,
	adminData: {},
	escriturasListadotab: 1,
	plusvaliasInfoHome: null,
	encontrarNotarioInfoHome: null,
	adminUserConfig: null,
	manageAdminTab: 0,
	tabs: [],
	activeTab: 0,
	currentNotario: null,
	markersCoords: null,
	notariosData: null,
	userLocation: { userLat: 0, userLng: 0 },
	notariosLocations: [{ codigoNotarioNotaria: '', distance: 0 }],
};

export default initialState;
